// PRODUCT SCREEN //

export const setProductDetailsItem = (item) => {
	localStorage.setItem("productDetailsItem", JSON.stringify(item));
};

export const getProductDetailsItem = () => {
	const ProductScreenItem = localStorage.getItem("productDetailsItem")
		? JSON.parse(localStorage.getItem("productDetailsItem"))
		: {};
	return ProductScreenItem;
};

export const cleanProductDetailsItem = () => {
	localStorage.removeItem("productDetailsItem");
};

// SIGNIN and REGISTER SCREEN //

export const setUserInfo = (data) => {
	localStorage.setItem("userWebRugInfo", JSON.stringify(data));
};

export const clearUser = () => {
	localStorage.removeItem("userWebRugInfo");
};

export const getUserInfo = () => {
	return localStorage.getItem("userWebRugInfo")
		? JSON.parse(localStorage.getItem("userWebRugInfo"))
		: {};
};
